import React from 'react';
import '../App.css';
import 'animate.css';
import '../App.js';
import '../index.css';
import demlight from '../assets/Images/dim lights cememt palnt 6.jpg';
import cement7 from '../assets/Images/Cement-Plant 7.jpg';
import quickIcon from '../assets/Images/quick response 1.jpg';
import qualityIcon from '../assets/Images/quality-icon-award-vector-25322832.jpg';
import supportIcon from '../assets/Images/247 response.jpg';
import cementRaw from '../assets/Images/Cement Raw Material Equipments 8.jpeg';
import clinker from '../assets/Images/clinker-production-equipments 9.jpg';
import soil from '../assets/Images/cement silos 4.webp';
import { Link } from 'react-router-dom';



const Hero = () => (
  <div className="hero-main">
    <div className="bg-light text-center py-2" id="home">
      <div className="container">
        <div className="row hero">
          <div className="col-md-6 text-uppercase py-2 animate__animated animate__fadeInDown animate__delay-1s">
            <h1>About valerion impex</h1>
          </div>
          <div className="col-md-6  text-center hero-cont animate__animated animate__fadeInDown animate__delay-1s">
            <p>In today’s fast paced world, having the right part can mean the difference between “on-time” and “off-line.” You can rely on Valerion Impex Pvt Ltd to consistently deliver the complex machined parts you need to keep operations humming in the railroad industries. Our reputation in the industry is unparalleled and is a direct reflection of our dedication to providing quality products at competitive prices. Combine this with our commitment to integrity at every level of our business and you have the obvious solution to all your part manufacturing and distribution needs. </p>
          </div>
        </div>
      </div>

      <div className="about mt-3">
        <h2>About Us</h2>
      </div>

    </div>

    <div className="container">
      <div className="row ">
        <div className="col-md-6 dem">
          <img src={demlight} alt="demlight" className="img-fluid mb-3 rounded" />
        </div>
        <div className="col-md-6 cem">
          <img src={cement7} alt="cement7" className="img-fluid mb-3 rounded" />
        </div>
      </div>
    </div>
    <div className="container text-center my-2">
      <h2 className="mb-2 fw-bold text-primary fs-1">The Ultimate Export Company</h2>
      <div className="row">
        <div className="col-md-4 mb-3">
          <img src={quickIcon} alt="Quick Response" className="img-fluid mb-1" style={{ maxWidth: '200px' }} />
          <h5 className="fw-semibold text-primary fs-2">Quick Response</h5>
        </div>
        <div className="col-md-4 mb-3">
          <img src={qualityIcon} alt="Genuine Quality" className="img-fluid mb-1" style={{ maxWidth: '200px' }} />
          <h5 className="fw-semibold text-primary fs-2">Genuine Quality</h5>
        </div>
        <div className="col-md-4 ">
          <img src={supportIcon} alt="24/7 Support" className="img-fluid " style={{ maxWidth: '200px' }} />
          <h5 className="fw-semibold text-primary fs-2">24/7 Support</h5>
        </div>
      </div>
    </div>
    <div className="conatiner animate__animated animate__fadeInDown animate__delay-1s">
      <div className="text text-center fw-semibold fs-5 mb-3">
        <span>Our business model is designed to ensure that every step of the</span> <br />
        <span>ordering and shipment process is thoroughly monitored, and</span> <br />
        <span>we pride ourselves on our responsiveness to our customers’</span> <br />
        <span>needs. We are supplier of cement plant equipments</span>
      </div>

      <div className="product-link mt-5 text-center mx-auto px-3 py-2">
        <h2>
          <Link to="/products/cement-production" className="text-decoration-none d-flex justify-content-center align-items-center ">
            Our Product
          </Link>
        </h2>
      </div>

    </div>

    <div className="container my-2 mt-4">
      <div className="row text-center">
        <div className="col-md-4 mb-4">
          <Link to="/products/cement-raw-materials">
            <img src={cementRaw} alt="Cement Raw Material Equipments" className="img-fluid faded" />
          </Link>
          <p className="mt-3 material">Cement Raw Material Equipments</p>
        </div>

        <div className="col-md-4 mb-4">
          <Link to="/products/cement-production">
            <img src={clinker} alt="Clinker Production Equipments" className="img-fluid faded" style={{ height: '310px', objectFit: 'cover' }} />
          </Link>
          <p className="mt-3 material">Clinker Production Equipments</p>
        </div>

        <div className="col-md-4">
          <Link to="/products/cement-equipments">
            <img src={soil} alt="Cement Equipments & Storage" className="img-fluid faded" />
          </Link>
          <p className="mt-3 material">Cement Equipments & Storage</p>
        </div>
      </div>
    </div>

  </div>
);

export default Hero;
